import { IconProps } from './IconProps';

export const AwayMode = ({ className, height = 25, width = 33 }: IconProps) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 33 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="#39A0FD" strokeWidth="2" fill="none" fillRule="evenodd" strokeLinecap="round">
      <path d="M15 16h15M27.914 19.484l3.463-3.464-3.402-3.402M22.5 20.466V22a2 2 0 0 1-2 2h-17a2 2 0 0 1-2-2V10c0-1.105 10.08-8.5 10.933-8.5.853 0 10.067 7.395 10.067 8.5v1.586" />
    </g>
  </svg>
);
